// Generated by scripts/logos (see its README): the stocks with a logo in public/logos.
export const LOGOS: ReadonlySet<string> = new Set<string>([
  "360ONE",
  "AADHARHFC",
  "AARTIIND",
  "AAVAS",
  "ABB",
  "ABBOTINDIA",
  "ABCAPITAL",
  "ABDL",
  "ABREL",
  "ABSLAMC",
  "ACC",
  "ACE",
  "ACMESOLAR",
  "ACUTAAS",
  "ADANIENSOL",
  "ADANIENT",
  "ADANIGREEN",
  "ADANIPORTS",
  "ADANIPOWER",
  "AEGISLOG",
  "AEGISVOPAK",
  "AETHER",
  "AFCONS",
  "AFFLE",
  "AIAENG",
  "AIIL",
  "AJANTPHARM",
  "ALKEM",
  "AMBER",
  "AMBUJACEM",
  "ANANDRATHI",
  "ANANTRAJ",
  "ANGELONE",
  "ANTHEM",
  "ANURAS",
  "APARINDS",
  "APLAPOLLO",
  "APOLLOHOSP",
  "APOLLOTYRE",
  "APTUS",
  "ARE&M",
  "ASAHIINDIA",
  "ASHOKLEY",
  "ASIANPAINT",
  "ASTERDM",
  "ASTRAL",
  "ATGL",
  "ATHERENERG",
  "ATUL",
  "AUBANK",
  "AUROPHARMA",
  "AVANTIFEED",
  "AWL",
  "AXISBANK",
  "AZAD",
  "BAJAJ-AUTO",
  "BAJAJFINSV",
  "BAJAJHFL",
  "BAJAJHLDNG",
  "BAJFINANCE",
  "BALKRISIND",
  "BALRAMCHIN",
  "BANDHANBNK",
  "BANKBARODA",
  "BANKINDIA",
  "BATAINDIA",
  "BBOX",
  "BDL",
  "BEL",
  "BELRISE",
  "BEML",
  "BERGEPAINT",
  "BHARATCOAL",
  "BHARATFORG",
  "BHARTIARTL",
  "BHARTIHEXA",
  "BHEL",
  "BIOCON",
  "BLS",
  "BLUESTARCO",
  "BOSCHLTD",
  "BPCL",
  "BRIGADE",
  "BRITANNIA",
  "BSE",
  "BSOFT",
  "CAMS",
  "CANBK",
  "CANFINHOME",
  "CANHLIFE",
  "CAPLIPOINT",
  "CARBORUNIV",
  "CARTRADE",
  "CASTROLIND",
  "CCL",
  "CDSL",
  "CEATLTD",
  "CEMPRO",
  "CENTRALBK",
  "CESC",
  "CGCL",
  "CGPOWER",
  "CHAMBLFERT",
  "CHENNPETRO",
  "CHOICEIN",
  "CHOLAFIN",
  "CHOLAHLDNG",
  "CIEINDIA",
  "CIPLA",
  "CLEAN",
  "CLEANMAX",
  "CMPDI",
  "COALINDIA",
  "COCHINSHIP",
  "COFORGE",
  "COHANCE",
  "COLPAL",
  "CONCOR",
  "CONCORDBIO",
  "COROMANDEL",
  "CPPLUS",
  "CRAFTSMAN",
  "CREDITACC",
  "CRISIL",
  "CROMPTON",
  "CUB",
  "CUMMINSIND",
  "CUPID",
  "CYIENT",
  "DABUR",
  "DALBHARAT",
  "DATAPATTNS",
  "DEEPAKFERT",
  "DEEPAKNTR",
  "DELHIVERY",
  "DEVYANI",
  "DIVISLAB",
  "DIXON",
  "DLF",
  "DMART",
  "DOMS",
  "DRREDDY",
  "ECLERX",
  "EICHERMOT",
  "EIDPARRY",
  "EIHOTEL",
  "ELECON",
  "ELGIEQUIP",
  "EMAMILTD",
  "EMCURE",
  "EMMVEE",
  "ENDURANCE",
  "ENGINERSIN",
  "ENRIN",
  "ESCORTS",
  "ETERNAL",
  "EXIDEIND",
  "FACT",
  "FEDERALBNK",
  "FINCABLES",
  "FIRSTCRY",
  "FIVESTAR",
  "FLUOROCHEM",
  "FORCEMOT",
  "FORTIS",
  "FRACTAL",
  "FSL",
  "GABRIEL",
  "GAIL",
  "GALLANTT",
  "GESHIP",
  "GICRE",
  "GILLETTE",
  "GLAND",
  "GLAXO",
  "GLENMARK",
  "GMDCLTD",
  "GMRAIRPORT",
  "GODFRYPHLP",
  "GODREJCP",
  "GODREJIND",
  "GODREJPROP",
  "GPIL",
  "GRANULES",
  "GRAPHITE",
  "GRASIM",
  "GRAVITA",
  "GROWW",
  "GRSE",
  "GVT&D",
  "HAL",
  "HAVELLS",
  "HBLENGINE",
  "HCLTECH",
  "HDBFS",
  "HDFCAMC",
  "HDFCBANK",
  "HDFCLIFE",
  "HEGAM",
  "HEROMOTOCO",
  "HEXT",
  "HINDALCO",
  "HINDCOPPER",
  "HINDPETRO",
  "HINDUNILVR",
  "HINDZINC",
  "HOMEFIRST",
  "HONASA",
  "HONAUT",
  "HSCL",
  "HUDCO",
  "HYUNDAI",
  "ICICIAMC",
  "ICICIBANK",
  "ICICIGI",
  "ICICIPRULI",
  "IDBI",
  "IDEA",
  "IDFCFIRSTB",
  "IEX",
  "IFCI",
  "IGIL",
  "IGL",
  "IIFL",
  "IKS",
  "INDHOTEL",
  "INDIACEM",
  "INDIAMART",
  "INDIANB",
  "INDIGO",
  "INDUSINDBK",
  "INDUSTOWER",
  "INFY",
  "INOXINDIA",
  "INOXWIND",
  "INTELLECT",
  "IOB",
  "IOC",
  "IPCALAB",
  "IRB",
  "IRCON",
  "IRCTC",
  "IREDA",
  "IRFC",
  "ITC",
  "ITCHOTELS",
  "ITI",
  "J&KBANK",
  "JAINREC",
  "JBMA",
  "JINDALSAW",
  "JINDALSTEL",
  "JIOFIN",
  "JKCEMENT",
  "JKTYRE",
  "JMFINANCIL",
  "JPPOWER",
  "JSL",
  "JSWCEMENT",
  "JSWENERGY",
  "JSWINFRA",
  "JSWSTEEL",
  "JUBLFOOD",
  "JUBLINGREA",
  "JWL",
  "JYOTICNC",
  "KAJARIACER",
  "KALYANKJIL",
  "KARURVYSYA",
  "KAYNES",
  "KEC",
  "KEI",
  "KFINTECH",
  "KIMS",
  "KIRLOSBROS",
  "KIRLOSENG",
  "KOTAKBANK",
  "KPIL",
  "KPITTECH",
  "KPRMILL",
  "KSB",
  "LALPATHLAB",
  "LAURUSLABS",
  "LEMONTREE",
  "LENSKART",
  "LGEINDIA",
  "LICHSGFIN",
  "LICI",
  "LINDEINDIA",
  "LLOYDSME",
  "LODHA",
  "LT",
  "LTF",
  "LTFOODS",
  "LTM",
  "LTTS",
  "LUPIN",
  "M&M",
  "M&MFIN",
  "MAHABANK",
  "MANAPPURAM",
  "MANKIND",
  "MARICO",
  "MARUTI",
  "MAXHEALTH",
  "MAZDOCK",
  "MCX",
  "MEDANTA",
  "MEESHO",
  "MFSL",
  "MGL",
  "MINDACORP",
  "MMTC",
  "MOTHERSON",
  "MOTILALOFS",
  "MPHASIS",
  "MRF",
  "MRPL",
  "MSUMI",
  "MUTHOOTFIN",
  "NAM-INDIA",
  "NATCOPHARM",
  "NATIONALUM",
  "NAUKRI",
  "NAVA",
  "NAVINFLUOR",
  "NBCC",
  "NCC",
  "NESTLEIND",
  "NETWEB",
  "NEULANDLAB",
  "NH",
  "NHPC",
  "NIACL",
  "NLCINDIA",
  "NMDC",
  "NSLNISP",
  "NTPC",
  "NTPCGREEN",
  "NUVAMA",
  "NUVOCO",
  "NYKAA",
  "OBEROIRLTY",
  "OFSS",
  "OIL",
  "OLAELEC",
  "OLECTRA",
  "ONESOURCE",
  "ONGC",
  "PAGEIND",
  "PARADEEP",
  "PATANJALI",
  "PAYTM",
  "PCBL",
  "PERSISTENT",
  "PETRONET",
  "PFC",
  "PFOCUS",
  "PGEL",
  "PHOENIXLTD",
  "PIDILITIND",
  "PIIND",
  "PINELABS",
  "PIRAMALFIN",
  "PNB",
  "PNBHOUSING",
  "POLICYBZR",
  "POLYCAB",
  "POLYMED",
  "POONAWALLA",
  "POWERGRID",
  "POWERINDIA",
  "PPLPHARMA",
  "PREMIERENE",
  "PRESTIGE",
  "PRIVISCL",
  "PSB",
  "PTCIL",
  "PVRINOX",
  "PWL",
  "RADICO",
  "RAILTEL",
  "RAINBOW",
  "RAMCOCEM",
  "RBLBANK",
  "RECLTD",
  "REDINGTON",
  "RELIANCE",
  "RHIM",
  "RITES",
  "RKFORGE",
  "RPOWER",
  "RRKABEL",
  "RUBICON",
  "RVNL",
  "SAGILITY",
  "SAIL",
  "SAILIFE",
  "SAMMAANCAP",
  "SANSERA",
  "SARDAEN",
  "SBICARD",
  "SBILIFE",
  "SBIN",
  "SCHAEFFLER",
  "SCHNEIDER",
  "SCI",
  "SHREECEM",
  "SHRIPISTON",
  "SHRIRAMFIN",
  "SHYAMMETL",
  "SIEMENS",
  "SIGNATURE",
  "SJVN",
  "SOBHA",
  "SOLARINDS",
  "SONACOMS",
  "SRF",
  "STARHEALTH",
  "SUMICHEM",
  "SUNDARMFIN",
  "SUNPHARMA",
  "SUNTV",
  "SUPREMEIND",
  "SUZLON",
  "SWANCORP",
  "SWIGGY",
  "SYNGENE",
  "SYRMA",
  "TARIL",
  "TATACAP",
  "TATACHEM",
  "TATACOMM",
  "TATACONSUM",
  "TATAELXSI",
  "TATAINVEST",
  "TATAPOWER",
  "TATASTEEL",
  "TATATECH",
  "TBOTEK",
  "TCS",
  "TDPOWERSYS",
  "TECHM",
  "TECHNOE",
  "TEGA",
  "TEJASNET",
  "TENNIND",
  "THANGAMAYL",
  "THERMAX",
  "TIINDIA",
  "TIMKEN",
  "TITAGARH",
  "TITAN",
  "TMCV",
  "TMPV",
  "TORNTPHARM",
  "TORNTPOWER",
  "TRENT",
  "TRIDENT",
  "TRITURBINE",
  "TTML",
  "TVSMOTOR",
  "UBL",
  "UCOBANK",
  "ULTRACEMCO",
  "UNIONBANK",
  "UNITDSPR",
  "UNOMINDA",
  "UPL",
  "URBANCO",
  "USHAMART",
  "UTIAMC",
  "VBL",
  "VEDL",
  "VIJAYA",
  "VMM",
  "VOLTAS",
  "VTL",
  "WAAREEENER",
  "WELCORP",
  "WELSPUNLIV",
  "WHIRLPOOL",
  "WIPRO",
  "WOCKPHARMA",
  "YESBANK",
  "ZEEL",
  "ZENSARTECH",
  "ZENTEC",
  "ZFCVINDIA",
  "ZYDUSLIFE",
  "ZYDUSWELL",
]);

/** A stock's logo file in public/logos: the symbol in lowercase kebab-case, '&' as '-and-'
 *  (M&M → m-and-m.webp, BAJAJ-AUTO → bajaj-auto.webp). */
export const logoPath = (symbol: string) =>
  `/logos/${symbol.toLowerCase().replace(/&/g, '-and-').replace(/-+/g, '-').replace(/^-|-$/g, '')}.webp`;
